export default function MyCoursesIcon({ className }: { className?: string }) {
  return (
    <div className={className}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5 15.75H12M10.5 15.75C9.8787 15.75 9.375 15.2463 9.375 14.625V12.75H9M10.5 15.75H7.5M9 12.75H8.625V14.625C8.625 15.2463 8.1213 15.75 7.5 15.75M9 12.75V15.75M7.5 15.75H6"
          stroke="currentColor"
          strokeWidth="1.5"
          stroke-linecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 2.25H6C3.87868 2.25 2.81802 2.25 2.15901 2.90901C1.5 3.56802 1.5 4.62868 1.5 6.75V8.25C1.5 10.3713 1.5 11.4319 2.15901 12.091C2.81802 12.75 3.87868 12.75 6 12.75H12C14.1213 12.75 15.1819 12.75 15.841 12.091C16.5 11.4319 16.5 10.3713 16.5 8.25V6.75C16.5 4.62868 16.5 3.56802 15.841 2.90901C15.1819 2.25 14.1213 2.25 12 2.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.932 6.92625L8.39175 5.33859C8.29913 5.2807 8.1921 5.25 8.08282 5.25C7.76092 5.25 7.5 5.51095 7.5 5.83284V9.16718C7.5 9.48908 7.76092 9.75 8.08282 9.75C8.1921 9.75 8.29913 9.71932 8.39175 9.66142L10.932 8.07375C11.1299 7.95008 11.25 7.73325 11.25 7.5C11.25 7.26672 11.1299 7.04989 10.932 6.92625Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
}
